import { isCustomVariableColumn } from '../constants-and-enums/smart-assistant-types';
import { LocalStorageService } from '../services/local-storage.service';

export function resolveStoredColumnMapping(): { [columnKey: string]: string } {
    const mapping: { [columnKey: string]: string } = {};
    for (const [key, header] of Object.entries(LocalStorageService.getSmartAssistantColumnMapping())) {
        if (!isCustomVariableColumn(key)) {
            mapping[key] = header;
        }
    }
    return mapping;
}

// CRD variables are company-specific, so their headers are never remembered.
export function rememberColumnHeader(key: string, header: string): { [columnKey: string]: string } {
    const mapping = resolveStoredColumnMapping();
    if (isCustomVariableColumn(key)) {
        return mapping;
    }

    if (header) {
        mapping[key] = header;
    } else {
        delete mapping[key];
    }
    LocalStorageService.setSmartAssistantColumnMapping(mapping);
    return mapping;
}

export function forgetStoredColumnMapping(): void {
    LocalStorageService.removeSmartAssistantColumnMapping();
}
